/**
 * Sleeps for the specified timeout, in milliseconds
 *
 * NOTE: This is a separate module controlling timeout as usually you can use `jest.useFakeTimers` for mocking in tests,
 * however, RTL's waitFor function uses setTimeout underneath, which causes conflicting issues.
 */
export default async function sleep(timeout) {
    return new Promise((resolve) => setTimeout(resolve, timeout));
}
